module.exports = "static/webpack/a7503851fdd87765ee9041d66dd42c66.svg";